import { all, has } from "ramda";
import React from "react";

export const isJSXElement = (element: any): element is JSX.Element => React.isValidElement(element)
//Check if it is a React JXS element
export const isJSXElementFromType = (element: any,props:string[]): element is JSX.Element => {
  return isJSXElement(element) && all((x:string) => has(x)(element))(props)
}

